import path from 'path';
import 'whatwg-fetch';
import Promise from 'promise-polyfill';

export default class Utils {
	static log(...args) {
		if (DEBUG) {
			console.debug(...args);
		}
	}

	static onLoad(callback) {
		if (document.readyState === 'complete') {
			callback.call(null, null);
		} else {
			window.addEventListener('load', (event) => {
				callback.call(null, event);
			}, false);
		}
	}

	static onWindowResize(callback) {
		window.addEventListener('resize', callback, false);
	}

	static onDomReady(callback) {
		function onReady(event) {
			document.removeEventListener('DOMContentLoaded', onReady);
			callback.call(null, event);
		}

		document.addEventListener('DOMContentLoaded', onReady);
	}

	static onDomUpdate(callback, runNow = false) {
		if (typeof _context !== 'undefined') {
			// On page load and snippets updates
			_context.lookup('Nittro.DI.Instance')
				.getService('snippetManager')
				.on('after-update', callback);

			if (runNow) {
				callback();
			}
		} else {
			// Only on page load
			Utils.onDomReady(callback);
		}
	}

	/**
	 * @param  {string} url
	 * @param  {Object} init
	 * @returns {Promise<Response>}
	 */
	static ajax(url, init = {}) {
		init.credentials = init.credentials || 'same-origin';
		return fetch(url, init);
	}

	/**
	 * @param {string} url
	 * @param {HTMLElement|null} element
	 * @returns {Promise}
	 */
	static loadSvgShapes(url, element = null) {
		if (!element) {
			element = document.createElement('div');
		}

		return Utils.ajax(url)
			.then(response => response.text())
			.then((text) => {
				element.innerHTML = text;

				const inner = element.querySelector('*');
				document.body.appendChild(inner);
				inner.style.visibility = 'hidden';
				inner.style.pointerEvents = 'none';
				inner.style.position = 'absolute';
				inner.style.top = '0';
				element.remove();
			});
	}

	/**
	 * @param {string} url
	 * @return {Promise}
	 */
	static loadAsset(url) {
		const head = document.getElementsByTagName('head')[0];
		const ext = path.extname(url);
		switch (ext) {
			case '.js': {
				return new Promise((resolve, reject) => {
					const script = document.createElement('script');
					script.type = 'text/javascript';
					script.src = url;
					script.onload = resolve;
					script.onerror = reject;
					head.appendChild(script);
				});
			}
			case '.css': {
				const link = document.createElement('link');
				link.rel = 'stylesheet';
				link.type = 'text/css';
				link.href = url;
				head.appendChild(link);
				return Promise.resolve(); // css do'not supports onload event
			}
			case '.svg': {
				return Utils.loadSvgShapes(url);
			}
			default: {
				return Promise.reject(new Error(`Cannot load dependency "${url}" - unexpected type "${ext}"`));
			}
		}
	}
}
